export const FETCH_JOBS_REQUEST = 'FETCH_JOBS_REQUEST';
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS';

export const FETCH_SUB_JOB_REQUEST = 'FETCH_SUB_JOB_REQUEST';
export const FETCH_SUB_JOB_SUCCESS = 'FETCH_SUB_JOB_SUCCESS';

export const FETCH_CURRENT_JOBS_REQUEST = 'FETCH_CURRENT_JOBS_REQUEST';
export const FETCH_CURRENT_JOBS_SUCCESS = 'FETCH_CURRENT_JOBS_SUCCESS';

export const SET_CURRENT_JOB = 'SET_CURRENT_JOB';